import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, vShow as _vShow } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = {
  class: "card-header border-0",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_ad_create_details",
  "aria-expanded": "true",
  "aria-controls": "kt_ad_create_details"
}
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = {
  id: "kt_ad_create_details",
  class: "collapse show"
}
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-2 col-form-label fw-bold fs-6 required" }
const _hoisted_9 = { class: "col-lg-4 fv-row" }
const _hoisted_10 = { class: "row mb-6" }
const _hoisted_11 = { class: "col-lg-2 col-form-label fw-bold fs-6" }
const _hoisted_12 = { class: "required" }
const _hoisted_13 = { class: "col-lg-4 fv-row" }
const _hoisted_14 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "fv-plugins-message-container" }
const _hoisted_17 = { class: "fv-help-block" }
const _hoisted_18 = { class: "col-lg-2 col-form-label fw-bold fs-6 required" }
const _hoisted_19 = { class: "col-lg-4 fv-row" }
const _hoisted_20 = { class: "row mb-6" }
const _hoisted_21 = {
  key: 0,
  class: "col-lg-2 col-form-label fw-bold fs-6"
}
const _hoisted_22 = { class: "required" }
const _hoisted_23 = {
  key: 1,
  class: "col-lg-4 fv-row"
}
const _hoisted_24 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "fv-plugins-message-container" }
const _hoisted_27 = { class: "fv-help-block" }
const _hoisted_28 = {
  key: 2,
  class: "col-lg-2 col-form-label fw-bold fs-6"
}
const _hoisted_29 = { class: "required" }
const _hoisted_30 = {
  key: 3,
  class: "col-lg-4 fv-row"
}
const _hoisted_31 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_32 = ["value"]
const _hoisted_33 = { class: "fv-plugins-message-container" }
const _hoisted_34 = { class: "fv-help-block" }
const _hoisted_35 = { class: "row mb-6" }
const _hoisted_36 = {
  key: 0,
  class: "row"
}
const _hoisted_37 = { class: "col-lg-2 col-form-label fw-bold fs-6" }
const _hoisted_38 = { class: "col-lg-4 fv-row" }
const _hoisted_39 = { class: "fv-plugins-message-container" }
const _hoisted_40 = { class: "fv-help-block" }
const _hoisted_41 = { class: "col-lg-2 col-form-label fw-bold fs-6" }
const _hoisted_42 = { class: "col-lg-4 fv-row" }
const _hoisted_43 = { class: "fv-plugins-message-container" }
const _hoisted_44 = { class: "fv-help-block" }
const _hoisted_45 = { class: "row mb-6" }
const _hoisted_46 = { class: "d-flex" }
const _hoisted_47 = { class: "col-lg-2 col-form-label fw-bold fs-6" }
const _hoisted_48 = { class: "required" }
const _hoisted_49 = { class: "form-check form-check-sm form-check-custom form-check-solid me-5" }
const _hoisted_50 = { class: "form-check-label user-select-none text-muted fs-7 p-2" }
const _hoisted_51 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_52 = { class: "form-check-label user-select-none text-muted fs-7 p-2" }
const _hoisted_53 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_54 = { class: "form-check-label user-select-none text-muted fs-7 p-2" }
const _hoisted_55 = {
  key: 0,
  class: "row"
}
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createElementVNode("span")
], -1)
const _hoisted_57 = { class: "col-lg-4 fv-row" }
const _hoisted_58 = { class: "fv-plugins-message-container" }
const _hoisted_59 = { class: "fv-help-block" }
const _hoisted_60 = { class: "row mb-6" }
const _hoisted_61 = { class: "col-lg-2 col-form-label fw-bold fs-6 required" }
const _hoisted_62 = { class: "col-lg-4 fv-row" }
const _hoisted_63 = { class: "fv-plugins-message-container" }
const _hoisted_64 = { class: "fv-help-block" }
const _hoisted_65 = { class: "row mb-6" }
const _hoisted_66 = { class: "col-lg-2 col-form-label fw-bold fs-6" }
const _hoisted_67 = { class: "col-lg-4 fv-row" }
const _hoisted_68 = { class: "fv-plugins-message-container" }
const _hoisted_69 = { class: "fv-help-block" }
const _hoisted_70 = { class: "row mb-6" }
const _hoisted_71 = { class: "d-flex" }
const _hoisted_72 = { class: "col-lg-2 col-form-label fw-bold fs-6" }
const _hoisted_73 = { class: "required" }
const _hoisted_74 = { class: "form-check form-check-sm form-check-custom form-check-solid me-5" }
const _hoisted_75 = { class: "form-check-label user-select-none text-muted fs-7 p-2" }
const _hoisted_76 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_77 = { class: "form-check-label user-select-none text-muted fs-7 p-2" }
const _hoisted_78 = {
  key: 0,
  class: "card-footer d-flex justify-content-end py-6 px-9"
}
const _hoisted_79 = {
  type: "submit",
  id: "kt_ad_create_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_80 = { class: "indicator-label" }
const _hoisted_81 = { class: "indicator-progress" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_83 = {
  key: 1,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_84 = {
  class: "card-header border-0",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_ad_create_attachments",
  "aria-expanded": "true",
  "aria-controls": "kt_ad_create_attachments"
}
const _hoisted_85 = { class: "card-title m-0" }
const _hoisted_86 = { class: "fw-bolder m-0" }
const _hoisted_87 = {
  id: "kt_ad_create_attachments",
  class: "collapse show"
}
const _hoisted_88 = { class: "card-body border-top p-9" }
const _hoisted_89 = {
  key: 0,
  class: "notice d-flex bg-light-primary rounded border-primary border border-dashed mb-9 p-6"
}
const _hoisted_90 = { class: "svg-icon svg-icon-2tx svg-icon-primary me-4" }
const _hoisted_91 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_92 = { class: "fw-bold" }
const _hoisted_93 = { class: "fs-6 text-gray-600" }
const _hoisted_94 = { class: "row mb-6" }
const _hoisted_95 = { class: "row mb-12" }
const _hoisted_96 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_97 = { class: "col-lg-12" }
const _hoisted_98 = {
  class: "image-input image-input-outline",
  "data-kt-image-input": "true"
}
const _hoisted_99 = {
  class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow",
  "data-kt-image-input-action": "change",
  "data-bs-toggle": "tooltip",
  title: "Change image"
}
const _hoisted_100 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cloud-upload-fill fs-6" }, null, -1)
const _hoisted_101 = /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  name: "avatar_create",
  multiple: ""
}, null, -1)
const _hoisted_102 = { class: "fv-plugins-message-container" }
const _hoisted_103 = { class: "fv-help-block" }
const _hoisted_104 = { class: "form-text" }
const _hoisted_105 = { class: "image-input-wrapper" }
const _hoisted_106 = { class: "thumbnail-grid" }
const _hoisted_107 = { class: "thumbnail-container" }
const _hoisted_108 = ["src"]
const _hoisted_109 = ["onClick"]
const _hoisted_110 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times" }, null, -1)
const _hoisted_111 = [
  _hoisted_110
]
const _hoisted_112 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_113 = ["disabled"]
const _hoisted_114 = { class: "indicator-label" }
const _hoisted_115 = { class: "indicator-progress" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_117 = {
  key: 2,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_118 = {
  class: "card-header border-0",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_ad_create_video_attachments",
  "aria-expanded": "true",
  "aria-controls": "kt_ad_create_video_attachments"
}
const _hoisted_119 = { class: "card-title m-0" }
const _hoisted_120 = { class: "fw-bolder m-0" }
const _hoisted_121 = {
  id: "kt_ad_create_video_attachments",
  class: "collapse show"
}
const _hoisted_122 = { class: "card-body border-top p-9" }
const _hoisted_123 = {
  key: 0,
  class: "notice d-flex bg-light-primary rounded border-primary border border-dashed mb-9 p-6"
}
const _hoisted_124 = { class: "svg-icon svg-icon-2tx svg-icon-primary me-4" }
const _hoisted_125 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_126 = { class: "fw-bold" }
const _hoisted_127 = { class: "fs-6 text-gray-600" }
const _hoisted_128 = { class: "row mb-6" }
const _hoisted_129 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_130 = { class: "col-lg-8" }
const _hoisted_131 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_132 = {
  class: "image-input image-input-wrapper",
  "data-kt-image-input": "true"
}
const _hoisted_133 = ["data-video", "data-sub-html"]
const _hoisted_134 = ["src"]
const _hoisted_135 = {
  class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow",
  "data-kt-image-input-action": "change",
  "data-bs-toggle": "tooltip",
  title: "Change image"
}
const _hoisted_136 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cloud-upload-fill fs-7" }, null, -1)
const _hoisted_137 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_138 = ["disabled"]
const _hoisted_139 = { class: "indicator-label" }
const _hoisted_140 = { class: "indicator-progress" }
const _hoisted_141 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_142 = {
  key: 3,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_143 = {
  class: "card-header border-0",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_ad_create_doc_attachments",
  "aria-expanded": "true",
  "aria-controls": "kt_ad_create_doc_attachments"
}
const _hoisted_144 = { class: "card-title m-0" }
const _hoisted_145 = { class: "fw-bolder m-0" }
const _hoisted_146 = {
  id: "kt_ad_create_doc_attachments",
  class: "collapse show"
}
const _hoisted_147 = { class: "card-body border-top p-9" }
const _hoisted_148 = {
  key: 0,
  class: "notice d-flex bg-light-primary rounded border-primary border border-dashed mb-9 p-6"
}
const _hoisted_149 = { class: "svg-icon svg-icon-2tx svg-icon-primary me-4" }
const _hoisted_150 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_151 = { class: "fw-bold" }
const _hoisted_152 = { class: "fs-6 text-gray-600" }
const _hoisted_153 = { class: "row mb-6" }
const _hoisted_154 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_155 = { class: "col-lg-12" }
const _hoisted_156 = {
  key: 0,
  class: "col-lg-12 fv-row"
}
const _hoisted_157 = {
  class: "image-input image-input-wrapper",
  "data-kt-image-input": "true"
}
const _hoisted_158 = ["src"]
const _hoisted_159 = {
  class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow",
  "data-kt-image-input-action": "change",
  "data-bs-toggle": "tooltip",
  title: "Change Doc"
}
const _hoisted_160 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cloud-upload-fill fs-7" }, null, -1)
const _hoisted_161 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_162 = ["disabled"]
const _hoisted_163 = { class: "indicator-label" }
const _hoisted_164 = { class: "indicator-progress" }
const _hoisted_165 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_lightgallery = _resolveComponent("lightgallery")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.can('create', 'ads'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('AdInfo')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Form, {
              class: "form",
              onSubmit: _ctx.onSubmitCreate,
              "validation-schema": _ctx.adsSchema
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("label", _hoisted_8, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate('users')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.selectedUser,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedUser) = $event)),
                        requierd: true,
                        label: "phone",
                        trackBy: "phone",
                        searchable: true,
                        canDeselect: false,
                        options: _ctx.appUsers,
                        placeholder: _ctx.translate('selectUsers'),
                        valueProp: "id",
                        noResultsText: _ctx.translate('noResultsFound')
                      }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("label", _hoisted_11, [
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.translate('adType')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "adTypesId",
                        class: "form-select form-select-solid form-select-lg text-capitalize",
                        modelValue: _ctx.selectedAdTypesId,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedAdTypesId) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", _hoisted_14, _toDisplayString(_ctx.translate('selectAdType')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.adTypes, (adType) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: adType.id,
                              value: adType.id
                            }, _toDisplayString(adType.titleAr), 9, _hoisted_15))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_ErrorMessage, { name: "adTypesId" })
                        ])
                      ])
                    ]),
                    _createElementVNode("label", _hoisted_18, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate('areas')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.selectedArea,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedArea) = $event)),
                        requierd: true,
                        label: "titleAr",
                        trackBy: "titleAr",
                        searchable: true,
                        canDeselect: false,
                        options: _ctx.areas,
                        placeholder: _ctx.translate('selectAreas'),
                        valueProp: "id",
                        noResultsText: _ctx.translate('noResultsFound')
                      }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    (
                _ctx.propertyTypesCategories && _ctx.propertyTypesCategories.length > 0
              )
                      ? (_openBlock(), _createElementBlock("label", _hoisted_21, [
                          _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.translate('propertyCategory')), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (
                _ctx.propertyTypesCategories && _ctx.propertyTypesCategories.length > 0
              )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _createVNode(_component_Field, {
                            as: "select",
                            name: "propertyCategoryId",
                            class: "form-select form-select-solid form-select-lg text-capitalize",
                            modelValue: _ctx.selectedPropertyCategoryId,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedPropertyCategoryId) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("option", _hoisted_24, _toDisplayString(_ctx.translate('selectPropertyCategories')), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propertyTypesCategories, (propertyCategory) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: propertyCategory.id,
                                  value: propertyCategory.id
                                }, _toDisplayString(propertyCategory.titleAr), 9, _hoisted_25))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _createVNode(_component_ErrorMessage, { name: "propertyCategoryId" })
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.propertyTypes && _ctx.propertyTypes.length > 0)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_28, [
                          _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.translate('propertyTypes')), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.propertyTypes && _ctx.propertyTypes.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          _createVNode(_component_Field, {
                            as: "select",
                            name: "propertyTypeId",
                            class: "form-select form-select-solid form-select-lg text-capitalize",
                            modelValue: _ctx.selectedPropertyTypesId,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedPropertyTypesId) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("option", _hoisted_31, _toDisplayString(_ctx.translate('selectPropertyTypes')), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propertyTypes, (propertyType) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: propertyType.id,
                                  value: propertyType.id
                                }, _toDisplayString(propertyType.titleAr), 9, _hoisted_32))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                              _createVNode(_component_ErrorMessage, { name: "propertyTypeId" })
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    (_ctx.selectedAdTypesId == 3 || _ctx.selectedAdTypesId == 4)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _createElementVNode("label", _hoisted_37, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.translate('numRooms')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_38, [
                            _createVNode(_component_Field, {
                              type: "number",
                              min: "0",
                              name: "numRooms",
                              autocomplete: "off",
                              class: "form-control form-control-lg form-control-solid",
                              placeholder: _ctx.translate('numRooms'),
                              modelValue: _ctx.numRooms,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.numRooms) = $event))
                            }, null, 8, ["placeholder", "modelValue"]),
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("div", _hoisted_40, [
                                _createVNode(_component_ErrorMessage, { name: "numRooms" })
                              ])
                            ])
                          ]),
                          _createElementVNode("label", _hoisted_41, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.translate('numBathrooms')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_42, [
                            _createVNode(_component_Field, {
                              type: "number",
                              min: "0",
                              name: "numBathrooms",
                              autocomplete: "off",
                              class: "form-control form-control-lg form-control-solid",
                              placeholder: _ctx.translate('numBathrooms'),
                              modelValue: _ctx.numBathrooms,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.numBathrooms) = $event))
                            }, null, 8, ["placeholder", "modelValue"]),
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("div", _hoisted_44, [
                                _createVNode(_component_ErrorMessage, { name: "numBathrooms" })
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("label", _hoisted_47, [
                        _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.translate('price')), 1)
                      ]),
                      _createElementVNode("label", _hoisted_49, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.priceVal) = $event)),
                          type: "radio",
                          value: "0"
                        }, null, 512), [
                          [_vModelRadio, _ctx.priceVal]
                        ]),
                        _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.translate('price')), 1)
                      ]),
                      _createElementVNode("label", _hoisted_51, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.priceVal) = $event)),
                          type: "radio",
                          value: "-1"
                        }, null, 512), [
                          [_vModelRadio, _ctx.priceVal]
                        ]),
                        _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.translate('askSeller')), 1)
                      ]),
                      _createElementVNode("label", _hoisted_53, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.priceVal) = $event)),
                          type: "radio",
                          value: "-2"
                        }, null, 512), [
                          [_vModelRadio, _ctx.priceVal]
                        ]),
                        _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.translate('priceNotAvailable')), 1)
                      ])
                    ]),
                    (_ctx.priceVal >= 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                          _hoisted_56,
                          _createElementVNode("div", _hoisted_57, [
                            _createVNode(_component_Field, {
                              type: "number",
                              min: "0",
                              name: "price",
                              autocomplete: "off",
                              class: "form-control form-control-lg form-control-solid",
                              placeholder: _ctx.translate('price'),
                              modelValue: _ctx.price,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.price) = $event))
                            }, null, 8, ["placeholder", "modelValue"]),
                            _createElementVNode("div", _hoisted_58, [
                              _createElementVNode("div", _hoisted_59, [
                                _createVNode(_component_ErrorMessage, { name: "price" })
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("label", _hoisted_61, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate('size')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_62, [
                      _createVNode(_component_Field, {
                        type: "number",
                        min: "0",
                        name: "size",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('size'),
                        modelValue: _ctx.size,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.size) = $event))
                      }, null, 8, ["placeholder", "modelValue"]),
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("div", _hoisted_64, [
                          _createVNode(_component_ErrorMessage, { name: "size" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("label", _hoisted_66, _toDisplayString(_ctx.translate('adDetails')), 1),
                    _createElementVNode("div", _hoisted_67, [
                      _createVNode(_component_Field, {
                        as: "textarea",
                        type: "text",
                        name: "adDetails",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('adDetailsLang'),
                        modelValue: _ctx.adDetails,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.adDetails) = $event))
                      }, null, 8, ["placeholder", "modelValue"]),
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("div", _hoisted_69, [
                          _createVNode(_component_ErrorMessage, { name: "adDetails" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("div", _hoisted_71, [
                      _createElementVNode("label", _hoisted_72, [
                        _createElementVNode("span", _hoisted_73, _toDisplayString(_ctx.translate('adOptions')), 1)
                      ]),
                      _createElementVNode("label", _hoisted_74, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.isHighQuality) = $event)),
                          type: "checkbox"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.isHighQuality]
                        ]),
                        _createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.translate('displayOnHomepage')), 1)
                      ]),
                      _createElementVNode("label", _hoisted_76, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.isSpecial) = $event)),
                          type: "checkbox"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.isSpecial]
                        ]),
                        _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.translate('featuredAd')), 1)
                      ])
                    ])
                  ])
                ]),
                (!_ctx.createdAd)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                      _createElementVNode("button", {
                        type: "reset",
                        class: "btn btn-white btn-active-light-primary me-2",
                        onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                      }, _toDisplayString(_ctx.translate('discard')), 1),
                      _createElementVNode("button", _hoisted_79, [
                        _createElementVNode("span", _hoisted_80, _toDisplayString(_ctx.translate('saveChanges')), 1),
                        _createElementVNode("span", _hoisted_81, [
                          _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                          _hoisted_82
                        ])
                      ], 512)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.can('create', 'ads'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
          _createElementVNode("div", _hoisted_84, [
            _createElementVNode("div", _hoisted_85, [
              _createElementVNode("h3", _hoisted_86, _toDisplayString(_ctx.translate('adImagesAttachments')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_87, [
            _createElementVNode("div", _hoisted_88, [
              (!_ctx.createdAd)
                ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                    _createElementVNode("span", _hoisted_90, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen045.svg" })
                    ]),
                    _createElementVNode("div", _hoisted_91, [
                      _createElementVNode("div", _hoisted_92, [
                        _createElementVNode("div", _hoisted_93, _toDisplayString(_ctx.translate('savingAdAttachmentNote')), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_94, [
                _createElementVNode("div", _hoisted_95, [
                  _createElementVNode("label", _hoisted_96, _toDisplayString(_ctx.translate('images')), 1),
                  _createElementVNode("div", _hoisted_97, [
                    _createElementVNode("div", _hoisted_98, [
                      _createElementVNode("div", {
                        class: "image-input-wrapper w-125px h-125px",
                        style: _normalizeStyle(`background-image: url(${_ctx.thumbnail})`)
                      }, null, 4),
                      _createElementVNode("label", _hoisted_99, [
                        _hoisted_100,
                        _createVNode(_component_Field, {
                          type: "file",
                          name: "images",
                          accept: ".png, .jpg, .jpeg",
                          multiple: true,
                          "max-files": 10,
                          modelValue: _ctx.imagesInput,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.imagesInput) = $event)),
                          onChange: _ctx.previewImages
                        }, null, 8, ["modelValue", "onChange"]),
                        _hoisted_101
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_102, [
                      _createElementVNode("div", _hoisted_103, [
                        _createVNode(_component_ErrorMessage, { name: "images" })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_104, _toDisplayString(_ctx.translate('allowedFileTypes')), 1),
                    _createElementVNode("div", _hoisted_105, [
                      _createElementVNode("div", _hoisted_106, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.thumbnailImages, (image, index) => {
                          return (_openBlock(), _createElementBlock("div", _hoisted_107, [
                            _createElementVNode("img", {
                              src: image,
                              class: "thumbnail-image img-ads"
                            }, null, 8, _hoisted_108),
                            _createElementVNode("button", {
                              class: "remove-button",
                              onClick: ($event: any) => (_ctx.removeImage(index))
                            }, _hoisted_111, 8, _hoisted_109)
                          ]))
                        }), 256))
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_112, [
              _createElementVNode("button", {
                type: "reset",
                class: "btn btn-white btn-active-light-primary me-2",
                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
              }, _toDisplayString(_ctx.translate('discard')), 1),
              _createElementVNode("button", {
                id: "kt_ad_create_attachments_images_submit",
                ref: "submitImagesButton",
                class: "btn btn-primary",
                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.onSubmitImages && _ctx.onSubmitImages(...args))),
                disabled: !_ctx.createdAd
              }, [
                _createElementVNode("span", _hoisted_114, _toDisplayString(_ctx.translate('saveChanges')), 1),
                _createElementVNode("span", _hoisted_115, [
                  _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                  _hoisted_116
                ])
              ], 8, _hoisted_113)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.can('create', 'ads'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
          _createElementVNode("div", _hoisted_118, [
            _createElementVNode("div", _hoisted_119, [
              _createElementVNode("h3", _hoisted_120, _toDisplayString(_ctx.translate('adVideoAttachments')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_121, [
            _createElementVNode("div", _hoisted_122, [
              (!_ctx.createdAd)
                ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                    _createElementVNode("span", _hoisted_124, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen045.svg" })
                    ]),
                    _createElementVNode("div", _hoisted_125, [
                      _createElementVNode("div", _hoisted_126, [
                        _createElementVNode("div", _hoisted_127, _toDisplayString(_ctx.translate('savingAdAttachmentNote')), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_128, [
                _createElementVNode("label", _hoisted_129, _toDisplayString(_ctx.translate('video')) + ": ", 1),
                _createElementVNode("div", _hoisted_130, [
                  (!_ctx.videoInput)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                        _createVNode(_component_Field, {
                          type: "file",
                          accept: "video/*",
                          name: "",
                          autocomplete: "off",
                          class: "form-control form-control-lg form-control-solid",
                          placeholder: _ctx.translate('adVideo'),
                          modelValue: _ctx.videoInput,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.videoInput) = $event)),
                          onChange: _ctx.previewVideo
                        }, null, 8, ["placeholder", "modelValue", "onChange"])
                      ]))
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("div", _hoisted_132, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_lightgallery, {
                        onInit: _ctx.onInit,
                        onBeforeSlide: _ctx.updateSlides,
                        "data-poster": "",
                        settings: { download: false, speed: 500, plugins: _ctx.plugins }
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            "data-video": `{"source": [{"src":"${_ctx.guideVideo}", "type":"video/mp4"}], "attributes": {"dynamic": false, "controls": true}}`,
                            "data-sub-html": `<h4> video - <a href='https://alhisba.com/' >alhisba.com </a></h4> <p> - video- </a></p>`
                          }, [
                            _createElementVNode("video", {
                              class: "image-input-wrapper d-inline-block w-auto h-200px overflow-hidden",
                              role: "button",
                              src: _ctx.guideVideo
                            }, null, 8, _hoisted_134)
                          ], 8, _hoisted_133)
                        ]),
                        _: 1
                      }, 8, ["onInit", "onBeforeSlide", "settings"])
                    ]),
                    _createElementVNode("label", _hoisted_135, [
                      _hoisted_136,
                      _createVNode(_component_Field, {
                        type: "file",
                        accept: "video/*",
                        name: "",
                        autocomplete: "off",
                        placeholder: _ctx.translate('adVideo'),
                        filename: "guideVideo",
                        modelValue: _ctx.videoInput,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.videoInput) = $event)),
                        onChange: _ctx.previewVideo
                      }, null, 8, ["placeholder", "modelValue", "onChange"])
                    ])
                  ], 512), [
                    [_vShow, _ctx.videoInput]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_137, [
              _createElementVNode("button", {
                type: "reset",
                class: "btn btn-white btn-active-light-primary me-2",
                onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
              }, _toDisplayString(_ctx.translate('discard')), 1),
              _createElementVNode("button", {
                id: "kt_ad_create_attachments_submit",
                ref: "submitVideoButton",
                class: "btn btn-primary",
                onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.onSubmitVideo && _ctx.onSubmitVideo(...args))),
                disabled: !_ctx.createdAd || !_ctx.videoInput
              }, [
                _createElementVNode("span", _hoisted_139, _toDisplayString(_ctx.translate('saveChanges')), 1),
                _createElementVNode("span", _hoisted_140, [
                  _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                  _hoisted_141
                ])
              ], 8, _hoisted_138)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.can('create', 'ads'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
          _createElementVNode("div", _hoisted_143, [
            _createElementVNode("div", _hoisted_144, [
              _createElementVNode("h3", _hoisted_145, _toDisplayString(_ctx.translate('adDocAttachments')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_146, [
            _createElementVNode("div", _hoisted_147, [
              (!_ctx.createdAd)
                ? (_openBlock(), _createElementBlock("div", _hoisted_148, [
                    _createElementVNode("span", _hoisted_149, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen045.svg" })
                    ]),
                    _createElementVNode("div", _hoisted_150, [
                      _createElementVNode("div", _hoisted_151, [
                        _createElementVNode("div", _hoisted_152, _toDisplayString(_ctx.translate('savingAdAttachmentNote')), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_153, [
                _createElementVNode("label", _hoisted_154, _toDisplayString(_ctx.translate('Doc')) + ": ", 1),
                _createElementVNode("div", _hoisted_155, [
                  (!_ctx.docInput)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_156, [
                        _createVNode(_component_Field, {
                          type: "file",
                          accept: ".pdf,application/pdf",
                          name: "",
                          autocomplete: "off",
                          class: "form-control form-control-lg form-control-solid",
                          placeholder: _ctx.translate('adDoc'),
                          modelValue: _ctx.docInput,
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.docInput) = $event)),
                          onChange: _ctx.previewDoc
                        }, null, 8, ["placeholder", "modelValue", "onChange"])
                      ]))
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("div", _hoisted_157, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_lightgallery, {
                        onInit: _ctx.onInitDoc,
                        onBeforeSlide: _ctx.updateSlidesDoc,
                        "data-poster": "",
                        settings: { download: false, speed: 500, plugins: _ctx.plugins }
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("iframe", {
                            class: "image-input-wrapper d-inline-block w-auto h-400px overflow-hidden",
                            src: _ctx.adsPdf,
                            type: "application/pdf"
                          }, null, 8, _hoisted_158)
                        ]),
                        _: 1
                      }, 8, ["onInit", "onBeforeSlide", "settings"])
                    ]),
                    _createElementVNode("label", _hoisted_159, [
                      _hoisted_160,
                      _createVNode(_component_Field, {
                        type: "file",
                        accept: ".pdf,application/pdf",
                        name: "",
                        autocomplete: "off",
                        placeholder: _ctx.translate('adDoc'),
                        filename: "adsPdf",
                        modelValue: _ctx.docInput,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.docInput) = $event)),
                        onChange: _ctx.previewDoc
                      }, null, 8, ["placeholder", "modelValue", "onChange"])
                    ])
                  ], 512), [
                    [_vShow, _ctx.docInput]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_161, [
              _createElementVNode("button", {
                type: "reset",
                class: "btn btn-white btn-active-light-primary me-2",
                onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
              }, _toDisplayString(_ctx.translate('discard')), 1),
              _createElementVNode("button", {
                id: "kt_ad_create_attachments_submit",
                ref: "submitDocButton",
                class: "btn btn-primary",
                onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.onSubmitDoc && _ctx.onSubmitDoc(...args))),
                disabled: !_ctx.createdAd || !_ctx.docInput
              }, [
                _createElementVNode("span", _hoisted_163, _toDisplayString(_ctx.translate('saveChanges')), 1),
                _createElementVNode("span", _hoisted_164, [
                  _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                  _hoisted_165
                ])
              ], 8, _hoisted_162)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}